import { jsx as _jsx } from "react/jsx-runtime";
import SkeletonDataGrid from '../../components/SkeletonDataGrid';
import { $t, useTranslation } from '../../hooks/useTranslation';
function AlertsLoading() {
    useTranslation();
    return (_jsx(SkeletonDataGrid, { columns: [
            { field: 'Status', headerName: $t('Status'), flex: 1.5 },
            { field: 'Receipt', headerName: $t('Receipt'), flex: 1.7 },
            { field: 'Date', headerName: $t('Date'), flex: 3 },
            { field: 'Employee', headerName: $t('Employee'), flex: 3 },
            { field: 'Category', headerName: $t('Category'), flex: 5 },
            { field: 'Vendor', headerName: $t('Vendor'), flex: 4 },
            { field: 'Reason', headerName: $t('Description'), flex: 10 },
            { field: 'Amount', headerName: $t('Amount'), flex: 3 },
            { field: '', headerName: '', flex: 1 }
        ], rows: [], skeletonRows: 5, sx: {
            width: '100%',
            '& .MuiDataGrid-virtualScroller': {
                overflow: 'hidden'
            }
        }, autoHeight: true, loading: true }));
}
export default AlertsLoading;
